module.exports = __webpack_public_path__ + "assets/img/box.01915596.svg";